import { ready } from "@/lib/ready";
import { loadCarousel, type CarouselOptions } from "@/share/carousel"
import { addClass } from "@/lib/dom/addClass";

export function tryInitCarousel(selector: string, options: Partial<CarouselOptions>) {
  const target = document.querySelector(selector);

  if (target) {
    addClass(target, 'jcarousel');

    loadCarousel(target as HTMLElement, options);
  }
}

export function InitLazyCarousel(){

  tryInitCarousel("#jcarousel-guarantee", {
    lazy: true,
    autoStart: true,
    interval: 10000,
    pagination: true,
    touch: true,
    // transitions: true,
    responsive: {
      0: 1,
    }
  })
  tryInitCarousel("#jcarousel-Brands", {
    lazy: true,
    autoStart: true,
    interval: 5000,
    pagination: true,
    touch: true,
    // transitions: true,
    responsive: {
      0: 2,
      324: 3,
      428: 4,
      534: 5,
    }
  })
}

ready(() => {

  const start = !import.meta.env.DEV;

  tryInitCarousel('#jcarousel-homepage-banner', {
    autoStart: start,
    autoWidth: false,
    touch: true,
    // transitions: true,
    interval: 8000
  })


  if(!document.querySelector("input.Is_Mobile"))  InitLazyCarousel()
});